import {TrackingClientStateHolder} from './providers/gtm/helpers/clientState';
import {
  ShouldPushToDataLayerObject,
  shouldPushToDataLayerObject,
} from './providers/gtm/helpers/datalayer';

export class TrackingClient {
  private state: TrackingClientStateHolder;
  constructor(state: TrackingClientStateHolder) {
    this.state = state;
  }

  track = (
    trackingFn: (
      state: TrackingClientStateHolder
    ) => ShouldPushToDataLayerObject
  ) => {
    const event = trackingFn(this.state);

    shouldPushToDataLayerObject(event, this.state);
  };

  trackWithoutPushToDataLayer = (
    trackingFn: (
      state: TrackingClientStateHolder
    ) => ShouldPushToDataLayerObject
  ) => {
    trackingFn(this.state);
  };
}
